import { lazy } from 'react';
/** Открывает форму заказа */
export const OrderFormPageAsync = lazy(() => import('./OrderForm/OrderFormPage'));